<template>
  <v-app
    class="application-interview-wrapper"
    :class="{ 'application-interview-wrapper--videoresume': isVideoresume }"
  >
    <v-container class="container-fixed">
      <div class="default-video-block">
        <div class="video_wrapper">
          <v-row justify="center">
            <v-col :sm="!sent ? 6 : 4" :md="!sent ? 6 : 4" :lg="!sent ? 6 : 4">
              <agreement
                v-if="agree !== true"
                :interview="interview"
                :country="vacancy_country"
                @input="setAgree"
              />

              <component
                :is="actualProcess"
                v-else
                :interview="interview"
                :token="token"
                :is-videoresume="isVideoresume"
                :loaded="loaded"
                @sent="setSent"
              />
            </v-col>
          </v-row>
        </div>

        <vfooter
          :type="'landing'"
          :is-videoresume="isVideoresume"
          :background="!isVideoresume ? '#e5e5e5' : '#fafafa'"
          :company_language="company_language"
        />
      </div>
    </v-container>
  </v-app>
</template>

<script>
  import { mapGetters } from 'vuex';
  import basic from './default.vue';
  import store from './stores.js';
  import { STORE_PREFIX } from './constants.js';
  import PROCESS_NAMES from '@/process/names';
  import agreement from '@/routes_new/outer/interview/landing/application/components/agreement';
  import vfooter from '@/routes_new/outer/components/vfooter.vue';
  const JtiInner = () =>
    import(
      /* webpackChunkName: "innerjti" */ '@/process/innerjti/common/components/interview/landing/index.vue'
    );

  export default {
    name: 'LandingApplication',

    components: {
      default: basic,
      agreement,
      vfooter,
      innerjti: JtiInner
    },

    mixins: [store],

    props: {
      token: {
        type: [String, Number],
        default: null
      },

      process: {
        type: String,
        default: 'default'
      }
    },

    data() {
      return {
        agree: null,
        sent: false
      };
    },

    computed: {
      ...mapGetters(STORE_PREFIX + 'interview', {
        interview: 'item',
        isVideoresume: 'isVideoresume',
        loaded: 'loaded'
      }),

      ...mapGetters('interview', ['company_language']),

      vacancy_country() {
        return this.interview && this.interview.vacancy && this.interview.vacancy.country
          ? this.interview.vacancy.country.code
          : null;
      },

      activeProcess() {
        return (
          this.$store.getters[STORE_PREFIX + 'interview/process'] ||
          this.$store.getters['landing/process']
        );
      },

      actualProcess() {
        if (
          PROCESS_NAMES.JTI_MIB === this.activeProcess ||
          PROCESS_NAMES.JTI_MIB_PIXELS === this.activeProcess ||
          PROCESS_NAMES.JTI_INNER === this.activeProcess
        ) {
          return 'innerjti';
        }

        return this.process;
      }
    },

    created() {
      this.agree = Boolean(
        localStorage.getItem('agree_' + this.token) && localStorage.getItem('agree_' + this.token)
      );
      this.$store.dispatch(STORE_PREFIX + 'interview/load', this.token).then(r => {
        let finish = r.data.data[0].active_modules.find(el => el.id === 'survey').is_finished;

        if (finish) {
          this.$router.push({
            name: 'interview',
            params: { token: this.token }
          });
          return false;
        }
      });
    },

    methods: {
      setAgree(v) {
        localStorage.setItem('agree_' + this.token, v);
        this.agree = v;
      },

      setSent(v) {
        this.sent = v;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .application-interview-wrapper {
    @media (max-width: 950px) {
      ::v-deep {
        .container-fixed .col-sm-6,
        .container-fixed .col-sm-4 {
          max-width: 100% !important;
        }
      }
    }
  }
  .video_wrapper {
    display: flex;
    align-items: center;
    padding: 30px 12px 76px;
    background: #e5e5e5;
    min-height: calc(100vh - 61px);
    box-sizing: border-box;

    @media (max-width: 767px) {
      background: #fff;
      padding: 0 12px;
    }
  }

  .application-interview-wrapper--videoresume {
    .video_wrapper {
      background: #fafafa;
    }
  }
</style>
